




import { Component, Vue } from 'vue-property-decorator';

@Component
export default class App extends Vue {
  created() {
    const lang = localStorage.getItem('lang') || 'zh';
    this.$i18n.locale = lang;
  }
}
